// frontend/src/components/layout/FooterLinks.js
import React from 'react';
import { Link } from 'react-router-dom'; // We use Link to avoid full page reloads
import appStyles from '../../App.module.css'; // adjust path as needed

const FooterLinks = () => {
  return (
    <div style={{ marginTop: '2em', textAlign: 'center', fontSize: '0.9rem' }}>
      <hr style={{ margin: '2em 0' }} />
      <p>
      <Link to="/chat" className="hover:underline">Chat</Link>
      {' | '}
      <Link to="/" className="hover:underline">Welcome</Link>
      {' | '}
      <Link to="/about" className="hover:underline">About</Link>
      {' | '}
        <Link to="/privacy" className="hover:underline">Privacy</Link>
        {' | '}
        <Link to="/faq" className="hover:underline">FAQ</Link>
        {' | '}
        <Link to="/help" className="hover:underline">Help</Link>
        <br />
        <Link to="/login" className="hover:underline">Login</Link>
        {' | '}
        <Link to="/register" className="hover:underline">Register</Link>
        {' | '}
        <Link to="/contact" className="hover:underline">Contact</Link>
        {' | '}
        <Link to="/terms" className="hover:underline">Terms</Link>
        {' | '}
        <Link to="/founder" className="hover:underline">Founder</Link>
      </p>
      <div className={appStyles.poweredBadge}>
  
    Powered by <a href="https://mindmesch.com" target="_blank" rel="noopener noreferrer"><span>Mind Mesch</span>
  </a>
</div>


    </div>
  );
};

export default FooterLinks;
